<template>
  <g>
    <path
      d="M6.25 10.21a.63.63 0 011.26 0v5.58a.63.63 0 01-1.26 0V10.2zm3.12 0a.63.63 0 011.26 0v5.58a.63.63 0 01-1.26 0V10.2zm3.14 0a.63.63 0 011.26 0v5.58a.63.63 0 01-1.26 0V10.2zM3.64 18.4c.06.64.6 1.11 1.25 1.11H15.1c.65 0 1.19-.49 1.25-1.11L17.5 6.5h-15l1.14 11.89zM18.22 2.65h-5.14v-.72c0-.8-.57-1.43-1.28-1.43H9.22c-.71 0-1.28.63-1.28 1.43v.72H2.78c-.71 0-1.28.63-1.28 1.42 0 .8.57 1.43 1.28 1.43h14.44c.71 0 1.28-.63 1.28-1.43 0-.79-.57-1.42-1.28-1.42"
    />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "DeleteIcon",
});
</script>
